<form [formGroup]="claimForm" (submit)="onSubmit()">
  <mat-form-field fxFlex>
    <mat-label>{{ 'dialog.charges.model-claim-search' | translate }}</mat-label>
    <mat-chip-grid #chipGrid>
      <mat-chip-row *ngFor="let chip of chips" (removed)="removeChip(chip)">
        {{ chip }}
        <button matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
      <input
        matInput
        [placeholder]="'dialog.charges.model-claim-search-placeholder' | translate"
        [matChipInputFor]="chipGrid"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="true"
        formControlName="chipInput"
        (matChipInputTokenEnd)="addChip($event)"
      >
    </mat-chip-grid>
    <mat-spinner *ngIf="loading$ | async; else showSubmit" matSuffix color="primary" [diameter]="24" class="mr-3"></mat-spinner>
    <ng-template #showSubmit>
      <button
        *ngIf="showTraceButton"
        type="button"
        matSuffix
        mat-icon-button
        [disabled]="traceButtonDisabled"
        [matTooltip]="'patient-details.estimate-card.advanced.mcs-trace-link' | translate"
        [attr.aria-label]="'patient-details.estimate-card.advanced.mcs-trace-link' | translate"
        data-model-claim-search-trace
        (click)="onTraceRequested()"
      >
        <mat-icon>receipt_long</mat-icon>
      </button>
      <button type="submit" matSuffix mat-icon-button>
        <mat-icon>search</mat-icon>
      </button>
    </ng-template>
    <mat-hint>{{ 'dialog.charges.model-claim-search-hint' | translate }}</mat-hint>
    <mat-hint *ngIf="noResults$ | async" align="end" class="text-warn">{{ 'dialog.charges.model-claim-search-no-results' | translate }}</mat-hint>
    <mat-error *ngIf="errorMessages$ | async as error"> {{ error }}</mat-error>
  </mat-form-field>
</form>
